import React, { Fragment } from "react";
import {TabItemProps} from "./Tabs.model";

const TabItem = ({ children }: TabItemProps) => (
  <Fragment>
    {children}
  </Fragment>
);

export default TabItem;
